import { tv, VariantProps } from "@/utils";

export const designer = tv({
  slots: {
    base: [
      "flex justify-center",
      "relative",
      "text-center",
      "overflow-hidden",
      "bg-green-900",
      "aspect-9/13",
      "rounded-lg",
      "before:absolute before:bottom-0 before:z-10 before:w-full before:h-1/2",
      "before:bg-gradient-to-b before:from-transparent before:to-black",
    ],
    name: [
      "absolute z-20 bottom-4 sm:bottom-8",
      "text-white",
      "max-w-[120px] sm:max-w-[160px]",
    ],
    image: ["object-cover", "object-center"],
  },
});

export type DesignerVariantProps = VariantProps<typeof designer>;

export type DesignerReturnVariantProps = ReturnType<typeof designer>;
